import { useState } from "react";
import { FaComments, FaFacebookMessenger, FaPhoneAlt } from "react-icons/fa";
import { SiZalo } from "react-icons/si";
import './chat-button.css'
import { useSettings } from "../../context/SettingsContext";

const ChatButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { settings } = useSettings();

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="chat-container">
      {/* Floating Chat Button */}
      <div className="chat-button" onClick={togglePopup}>
        <FaComments className="chat-icon" />
        <span className="chat-text">Chat ngay</span>
      </div>

      {/* Chat Popup */}
      {isOpen && (
        <div className="chat-popup">
          <a
            href={settings?.contact_messenger_url || "https://iampesmobile.com"}
            target="_blank"
            rel="noopener noreferrer"
            className="chat-option"
          >
            <FaFacebookMessenger className="chat-option-icon" />
            Liên hệ qua Messenger
          </a>
          <a
            href={settings?.contact_zalo_url || "https://iampesmobile.com"}
            target="_blank"
            rel="noopener noreferrer"
            className="chat-option"
          >
            <SiZalo className="chat-option-icon" />
            Liên hệ qua Zalo
          </a>

          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="chat-option"
          >
            <FaPhoneAlt className="chat-option-icon" />
            {settings?.phone || "No Phone Number"}
          </a>
        </div>
      )}
    </div>
  );
};

export default ChatButton;
